import React from 'react';
import Header from './Header';
import ConciergeSignal from '../assets/jackpot-signal.jpg';
import { BoltIcon, HeartIcon, LightBulbIcon } from '@heroicons/react/24/outline';
import '@fontsource/oswald'; // Ensures oswald is loaded

const AboutUs = () => {
  return (
    <div
      className="min-h-screen bg-cover bg-center text-white"
      style={{ backgroundImage: `url(${ConciergeSignal})` }}
    >
      <div className="bg-black bg-opacity-80 min-h-screen">
        <Header />

        <div className="max-w-7xl mx-auto px-6 py-16 space-y-16 animate-fade-in">
          <h1
            className="text-center px-4 text-5xl sm:text-5xl md:text-6xl font-bold leading-tight"
            style={{
              fontFamily: "'oswald', sans-serif",
              letterSpacing: '-0.02em',
            }}
          >
            Concierge, Reimagined.
          </h1>


          <div className="flex flex-col md:flex-row md:space-x-12 items-center">
            <div className="bg-white bg-opacity-10 rounded-lg p-6 max-w-2xl mx-auto text-white transition-opacity duration-1000 ease-in">
              <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
              <p className="mb-4">
                At Jackpot Concierge, our mission is to use technology to redefine luxury service in Las Vegas
                by delivering fast, intelligent, and personalized concierge and trip planning services.
              </p>
              <p className="mb-4">
                Founded to restore the gold standard in hospitality, we provide on the go access to world class service through our 
                mobile app, ensuring convenience, value, and excellence are always within reach.
              </p>
              <p>
                In a city where service has become secondary, we put guests first with unmatched speed, 
                seamless execution, and an unwavering commitment to your satisfaction.
              </p>
            </div>
          </div>

          <div className="text-center">
            <h2 className="text-3xl font-semibold mb-12">Core Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              <div className="flex flex-col items-center text-center bg-white bg-opacity-10 p-6 rounded-lg transition-opacity duration-1000 delay-100">
                <BoltIcon className="h-12 w-12 text-red-500 mb-4" />
                <h3 className="text-xl font-bold mb-2">Speed</h3>
                <p>
                We prioritize rapid response and seamless delivery because your time is valuable.
                 Whether it is a last minute reservation or an urgent request, we move at your pace. Fast, efficient, and always on point.
                </p>
              </div>
              <div className="flex flex-col items-center text-center bg-white bg-opacity-10 p-6 rounded-lg transition-opacity duration-1000 delay-200">
                <HeartIcon className="h-12 w-12 text-red-500 mb-4" />
                <h3 className="text-xl font-bold mb-2">Service</h3>
                <p>
                  Exceptional service is the heart of everything we do. We go beyond basic assistance to anticipate
                  needs, exceed expectations, and create memorable experiences that reflect the highest standards
                  of Las Vegas hospitality.
                </p>
              </div>
              <div className="flex flex-col items-center text-center bg-white bg-opacity-10 p-6 rounded-lg transition-opacity duration-1000 delay-300">
                <LightBulbIcon className="h-12 w-12 text-red-500 mb-4" />
                <h3 className="text-xl font-bold mb-2">Aptitude</h3>
                <p>
                  Our team combines expertise, insight, and instinct to navigate the city's changing landscape.
                  We solve problems before they arise and offer solutions with precision and confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
